import ENV from './domain'
import axios from './XHR'
// import Store from '../store'

const domain = process.env.NODE_ENV === 'production' ? ENV.PROD_ENV : ENV.DEV_ENV;

export default {
    /**
     * 获取文章列表
     */
    getPostList (params) {
        return axios.get(`${domain}/postList`)
    },
    getPostDetails (params) {
        return axios.get(`${domain}/postDetails/${params}`)
    },
    publishPost (params) {
        return axios.post(`${domain}/publishPost`, params)
    },
    /**
     * 获取标签列表
     */
    getTagList (params) {
        return axios.get(`${domain}/taglist`)
    },
    /**
     * 获取私密链接
     */
    getUrl (params) {
        return axios.post(`${domain}/getUrl`, params)
    }
}